import React, { FC, Dispatch, SetStateAction } from 'react';
import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import PropertyCommentsView from './PropertyCommentsView';
import useGetPropertyComments from '../../../../hooks/api/Property/useGetPropertyComments';

type PropertyCommentsModalProps = {
  isOpen: boolean;
  propertyId: string;
  setIsPropertyCommentsModalOpen: Dispatch<SetStateAction<boolean>>;
}

const PropertyCommentsModal: FC<PropertyCommentsModalProps> = ({ isOpen, setIsPropertyCommentsModalOpen, propertyId }) => {
  const { commentData, refetchCommentData } = useGetPropertyComments(propertyId);

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50 w-full" onClose={setIsPropertyCommentsModalOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all px-10 pt-10 w-full mx-5 lg:mx-96 max-h-contain">
                <div className='card justify-center'>
                  <PropertyCommentsView
                    propertyId={propertyId}
                    setIsPropertyCommentsModalOpen={setIsPropertyCommentsModalOpen}
                    commentData={commentData}
                    refetchCommentData={refetchCommentData}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default PropertyCommentsModal;
